import { defineComponent as a, createElementBlock as r, openBlock as f, createVNode as n, withCtx as i, createElementVNode as s, renderSlot as l, unref as m, createTextVNode as c } from "vue";
import u from "./index37.js";
import h from "./index34.js";
import k from "./index628.js";
const _ = { "data-component": "CsAppModal" }, v = { class: "pt-8 pb-40" }, C = { class: "flex items-center gap-24 mb-24" }, b = { class: "text-h3 font-bold-headline text-pretty" }, O = /* @__PURE__ */ a({
  __name: "CsAppModal",
  props: {
    headerText: { default: "Schon entdeckt?" },
    isOpen: { type: Boolean }
  },
  emits: ["update:isOpen", "downloadClick", "close"],
  setup(x, { emit: d }) {
    const o = d;
    function p(e) {
      o("update:isOpen", e), e || o("close");
    }
    return (e, t) => (f(), r("div", _, [
      n(h, {
        visible: e.isOpen,
        headerText: e.headerText,
        "onUpdate:visible": p
      }, {
        default: i(() => [
          s("div", v, [
            s("div", C, [
              n(m(k), { class: "shrink-0" }),
              s("div", b, [
                l(e.$slots, "headline")
              ])
            ]),
            l(e.$slots, "features"),
            n(u, {
              href: "https://nz8ie.app.link/fY0lhFIepGb",
              class: "justify-center w-full mt-32",
              target: "_blank",
              rel: "nofollow noopener",
              onClick: t[0] || (t[0] = (w) => o("downloadClick"))
            }, {
              default: i(() => [
                l(e.$slots, "linkText", {}, () => [
                  t[1] || (t[1] = c(" App downloaden "))
                ])
              ]),
              _: 3
            })
          ])
        ]),
        _: 3
      }, 8, ["visible", "headerText"])
    ]));
  }
});
export {
  O as default
};
